module.exports = __webpack_public_path__ + "media/images/staging_banner2-9a27c06bf71a831ecc94056bced02b78.jpg";